import BaseQuery from "@/stateManagement/BaseQuery";
import { filterNilValue } from "@datorama/akita";
import { map } from "rxjs";
import { singleton } from "tsyringe";

import type { RewardsProgramAccountState } from "../store/RewardsProgramAccountStore";
import RewardsProgramAccountStore from "../store/RewardsProgramAccountStore";

@singleton()
class RewardsProgramAccountQuery extends BaseQuery<RewardsProgramAccountState> {
    constructor(protected store: RewardsProgramAccountStore) {
        super(store);
    }

    programAccount$ = this.select((state) => state.programAccount);
    points$ = this.select((state) => state.programAccount?.points).pipe(
        map((points) => points || null)
    );

    customerCurrentTier$ = this.select(
        (state) => state.programAccount?.tier
    ).pipe(map((tier) => tier?.currentTier || null));

    marketingData$ = this.select(
        (state) => state.programAccount?.marketing
    ).pipe(
        filterNilValue(),
        map((data) => data)
    );

    referralData$ = this.select((state) => state.programAccount?.referral).pipe(
        map((data) => data || null)
    );

    status$ = this.select((state) => state.status);
}

export default RewardsProgramAccountQuery;
